import { FC } from 'react'
import { Stack } from '@mui/material'
import { AlarmDetails } from '../../../api/models'
import { EngagementTag } from './EngagementInfoBox/EngagementTag'
import AlarmTriggeredIcon from '../../../assets/images/alarm-trigger-icon.svg?react'
import { useLocation } from '../../../api/apiQueries'
import { formatEngagementDate } from './ertUtils'

interface AlarmInfoBoxProps {
  alarm: AlarmDetails
}

export const AlarmInfoBox: FC<AlarmInfoBoxProps> = ({ alarm }) => {
  const location = useLocation(alarm.locationId).data

  return (
    <Stack direction="row" sx={{ flex: '1', alignItems: 'flex-end', justifyContent: 'space-between' }}>
      <Stack direction="row" sx={{ alignItems: 'flex-end', justifyContent: 'center' }}>
        <Stack direction="row" sx={{ gap: '1rem', paddingLeft: '1rem', alignItems: 'flex-end' }} data-testid="engagement-info-box-tags">
          <EngagementTag label="Alarm ID" details={[alarm.id]} data-testid="info-box-tag-engagement-id" />
          <EngagementTag
            label="Alarm Triggered"
            details={[formatEngagementDate(alarm.createdTimestamp, location?.address?.timeZone)]}
            icon={<AlarmTriggeredIcon />}
            data-testid="info-box-tag-engagement-triggered"
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
